import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { endDateValidator, startDateValidator } from '@/common/form/validators/dateValidators'
import { CtrtOwnerCust } from './formFields/CtrtOwnerCust';

export const CtrtForm = ({ entityId }) => {
  
  const augFieldDefs = (fieldToFieldDef) => {

    fieldToFieldDef.ownerCustId.component = <CtrtOwnerCust key="ownerCustId" fieldDef={fieldToFieldDef.ownerCustId}/>;

    fieldToFieldDef.startDate.validators = [startDateValidator];
    fieldToFieldDef.endDate.validators = [endDateValidator]
  }

  return (
    <EntityForm entity="CTRT" entityId={entityId} augFieldDefs={augFieldDefs} />
  )
}